'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var dagPB = require('@ipld/dag-pb');

var cid = require('multiformats/cid');

var debug = require('debug');

var ipfsUnixfs = require('ipfs-unixfs');

var hamtUtils = require('./hamt-utils.js');

var errCode = require('err-code');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var dagPB__namespace = /*#__PURE__*/_interopNamespace(dagPB);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var log = debug__default["default"]('ipfs:mfs:core:utils:remove-link');

function removeLink(_x, _x2) {
  return _removeLink.apply(this, arguments);
}

function _removeLink() {
  _removeLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context, options) {
    var parent, parentCid, block, meta;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            parent = options.parent;

            if (!options.parentCid) {
              _context4.next = 10;
              break;
            }

            parentCid = cid.CID.asCID(options.parentCid);

            if (!(parentCid === null)) {
              _context4.next = 5;
              break;
            }

            throw errCode__default["default"](new Error('Invalid CID passed to removeLink'), 'EINVALIDPARENTCID');

          case 5:
            log("Loading parent node ".concat(parentCid));
            _context4.next = 8;
            return context.repo.blocks.get(parentCid);

          case 8:
            block = _context4.sent;
            parent = dagPB__namespace.decode(block);

          case 10:
            if (parent) {
              _context4.next = 12;
              break;
            }

            throw errCode__default["default"](new Error('No parent node or CID passed to removeLink'), 'EINVALIDPARENT');

          case 12:
            if (options.name) {
              _context4.next = 14;
              break;
            }

            throw errCode__default["default"](new Error('No child name passed to removeLink'), 'EINVALIDCHILDNAME');

          case 14:
            if (parent.Data) {
              _context4.next = 16;
              break;
            }

            throw errCode__default["default"](new Error('Parent node had no data'), 'ERR_INVALID_NODE');

          case 16:
            meta = ipfsUnixfs.UnixFS.unmarshal(parent.Data);

            if (!(meta.type === 'hamt-sharded-directory')) {
              _context4.next = 20;
              break;
            }

            log("Removing ".concat(options.name, " from sharded directory"));
            return _context4.abrupt("return", removeFromShardedDirectory(context, _objectSpread(_objectSpread({}, options), {}, {
              parent: parent
            })));

          case 20:
            log("Removing link ".concat(options.name, " regular directory"));
            return _context4.abrupt("return", removeFromDirectory(context, _objectSpread(_objectSpread({}, options), {}, {
              parent: parent
            })));

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _removeLink.apply(this, arguments);
}

var removeFromDirectory = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, options) {
    var parentBlock, hasher, hash, parentCid;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options.parent.Links = options.parent.Links.filter(function (link) {
              return link.Name !== options.name;
            });
            _context.next = 3;
            return dagPB__namespace.encode(options.parent);

          case 3:
            parentBlock = _context.sent;
            _context.next = 6;
            return context.hashers.getHasher(options.hashAlg);

          case 6:
            hasher = _context.sent;
            _context.next = 9;
            return hasher.digest(parentBlock);

          case 9:
            hash = _context.sent;
            parentCid = cid.CID.create(options.cidVersion, dagPB__namespace.code, hash);
            _context.next = 13;
            return context.repo.blocks.put(parentCid, parentBlock);

          case 13:
            log("Updated regular directory ".concat(parentCid));
            return _context.abrupt("return", {
              node: options.parent,
              cid: parentCid
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function removeFromDirectory(_x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var removeFromShardedDirectory = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, options) {
    var _yield$hamtUtils$gene, rootBucket, path, _yield$updateShard, node;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return hamtUtils.generatePath(context, options.name, options.parent);

          case 2:
            _yield$hamtUtils$gene = _context2.sent;
            rootBucket = _yield$hamtUtils$gene.rootBucket;
            path = _yield$hamtUtils$gene.path;
            _context2.next = 7;
            return rootBucket.del(options.name);

          case 7:
            _context2.next = 9;
            return updateShard(context, path, options.name, options);

          case 9:
            _yield$updateShard = _context2.sent;
            node = _yield$updateShard.node;
            return _context2.abrupt("return", hamtUtils.updateHamtDirectory(context, node.Links, rootBucket, options));

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function removeFromShardedDirectory(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var updateShard = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context, positions, name, options) {
    var last, bucket, prefix, node, link, links, result, cid, size, newName, _link;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            last = positions.pop();

            if (last) {
              _context3.next = 3;
              break;
            }

            throw errCode__default["default"](new Error('Could not find parent'), 'EINVALIDPARENT');

          case 3:
            bucket = last.bucket, prefix = last.prefix, node = last.node;

            if (node) {
              _context3.next = 6;
              break;
            }

            throw errCode__default["default"](new Error('Could not find parent'), 'EINVALIDPARENT');

          case 6:
            link = node.Links.find(function (link) {
              return (link.Name || '').substring(0, 2) === prefix;
            });

            if (link) {
              _context3.next = 9;
              break;
            }

            throw errCode__default["default"](new Error("No link found with prefix ".concat(prefix, " for file ").concat(name)), 'ERR_NOT_FOUND');

          case 9:
            if (!(link.Name === "".concat(prefix).concat(name))) {
              _context3.next = 15;
              break;
            }

            log("Removing existing link ".concat(link.Name));
            links = node.Links.filter(function (nodeLink) {
              return nodeLink.Name !== link.Name;
            });
            _context3.next = 14;
            return bucket.del(name);

          case 14:
            return _context3.abrupt("return", hamtUtils.updateHamtDirectory(context, links, bucket, options));

          case 15:
            log("Descending into sub-shard ".concat(link.Name, " for ").concat(prefix).concat(name));
            _context3.next = 18;
            return updateShard(context, positions, name, options);

          case 18:
            result = _context3.sent;
            cid = result.cid;
            size = result.size;
            newName = prefix;

            if (result.node.Links.length === 1) {
              log("Removing subshard for ".concat(prefix));
              _link = result.node.Links[0];
              newName = "".concat(prefix).concat((_link.Name || '').substring(2));
              cid = _link.Hash;
              size = _link.Tsize || 0;
            }

            log("Updating shard ".concat(prefix, " with name ").concat(newName));
            return _context3.abrupt("return", updateShardParent(context, bucket, node, prefix, newName, size, cid, options));

          case 25:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function updateShard(_x7, _x8, _x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();

var updateShardParent = function updateShardParent(context, bucket, parent, oldName, newName, size, cid, options) {
  var parentLinks = parent.Links.filter(function (link) {
    return link.Name !== oldName;
  });
  parentLinks.push({
    Name: newName,
    Tsize: size,
    Hash: cid
  });
  return hamtUtils.updateHamtDirectory(context, parentLinks, bucket, options);
};

exports.removeLink = removeLink;